import { atom } from "jotai";

import { bookingCourtAtom } from "../stores";

export const getStartSlotIdFromCourt = atom((get) => {
  const court = get(bookingCourtAtom);
  return court?.startSlotId;
});
